import { render, staticRenderFns } from "./wxaicp.vue?vue&type=template&id=27e5581b&"
import script from "./wxaicp.vue?vue&type=script&lang=ts&"
export * from "./wxaicp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports